import { baseApi } from "./baseApi";

const SEND_OUT_BASE_URL = "/sendOut";

export const sendOutApi = baseApi.injectEndpoints({
  tagTypes: ["SendOut"],

  endpoints: (builder) => ({
    addSendOut: builder.mutation({
      query: (payload) => ({
        url: SEND_OUT_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "SendOut", id: _id },
        { type: "SendOut", id: "LIST" },
      ],
    }),

    listSendOut: builder.query({
      query: (params) => ({
        url: SEND_OUT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "SendOut",
                id: _id,
              })),
              { type: "SendOut", id: "LIST" },
            ]
          : [{ type: "SendOut", id: "LIST" }],
    }),

    getSendOutPendingDeliveryList: builder.query({
      query: (params) => ({
        url: `${SEND_OUT_BASE_URL}/sendOutPendingDeliveryList`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "SendOut", id: _id })),
              { type: "SendOut", id: "LIST" },
            ]
          : [{ type: "SendOut", id: "LIST" }],
    }),

    getSendOutPendingDeliverySummary: builder.query({
      query: () => ({
        url: `${SEND_OUT_BASE_URL}/sendOutPendingDeliverySummary`,
      }),
      providesTags: [{ type: "SendOut", id: "SUMMARY" }],
    }),

    sendOutListFilteredForDriver: builder.query({
      query: (params) => ({
        url: `${SEND_OUT_BASE_URL}/sendOutListFilteredForDriver`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "SendOut",
                id: _id,
              })),
              { type: "SendOut", id: "LIST" },
            ]
          : [{ type: "SendOut", id: "LIST" }],
    }),

    getDDLSendOut: builder.query({
      query: (params) => ({
        url: `${SEND_OUT_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "SendOut",
                id: _id,
              })),
              { type: "SendOut", id: "DDL" },
            ]
          : [{ type: "SendOut", id: "DDL" }],
    }),

    getSendOutDetail: builder.query({
      query: (id) => `${SEND_OUT_BASE_URL}/${id}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "SendOut", id: _id },
        { type: "SendOut", id: "LIST" },
      ],
    }),
    updateSendOut: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${SEND_OUT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "SendOut", id },
        { type: "SendOut", id: "LIST" },
      ],
    }),
    markShipmentsReturning: builder.mutation({
      query: (payload) => ({
        url: `${SEND_OUT_BASE_URL}/return`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { shipmentIds }) => [
        { type: "SendOut", id: "LIST" },
        ...shipmentIds.map((id) => ({ type: "Shipment", id })),
      ],
    }),

    listShipmentForSendOuts: builder.query({
      query: ({ sendOutId, page, limit }) => ({
        url: `${SEND_OUT_BASE_URL}/${sendOutId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id: id }) => [
        { type: "SendOut", id },
        { type: "SendOut", id: "LIST" },
      ],
    }),
    // Get shipment dropdown list for SendOut
    getDDLShipmentListForSendOut: builder.query({
      query: (params) => ({
        url: `${SEND_OUT_BASE_URL}/ddl/sendOutShipments`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "Shipment",
                id: _id,
              })),
              { type: "Shipment", id: "DDL" },
            ]
          : [{ type: "Shipment", id: "DDL" }],
    }),
  }),
});

export const {
  useAddSendOutMutation,
  useListSendOutQuery,
  useLazyListSendOutQuery,
  useLazySendOutListFilteredForDriverQuery,
  useLazyListShipmentForSendOutsQuery,
  useLazyGetDDLSendOutQuery,
  useGetSendOutDetailQuery,
  useUpdateSendOutMutation,
  useMarkShipmentsReturningMutation,
  useLazyGetDDLShipmentListForSendOutQuery,
  useLazyGetSendOutPendingDeliveryListQuery,
  useLazyGetSendOutPendingDeliverySummaryQuery,
} = sendOutApi;
